import { render, staticRenderFns } from "./swPress.vue?vue&type=template&id=66a108e1&scoped=true&"
import script from "./swPress.vue?vue&type=script&lang=js&"
export * from "./swPress.vue?vue&type=script&lang=js&"
import style0 from "./swPress.vue?vue&type=style&index=0&id=66a108e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a108e1",
  null
  
)

export default component.exports